
import React from 'react';
import { UserIcon } from '../../../../components/icons';
import Input from '../../../../components/ui/Input';
import { ClientProfile } from '../../../../types';

interface PersonalInfoCardProps {
    formData: ClientProfile;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PersonalInfoCard: React.FC<PersonalInfoCardProps> = ({ formData, onChange }) => {
    return (
        <div className="card-premium p-4">
            <h3 className="text-sm font-bold text-secondary mb-4">Informações Pessoais</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Input
                    icon={<UserIcon className="w-4 h-4" />}
                    name="name"
                    autoComplete="name"
                    value={formData.name || ''}
                    onChange={onChange}
                    placeholder="Nome Completo"
                />
                <Input
                    type="email"
                    name="email"
                    autoComplete="email"
                    value={formData.email || ''}
                    onChange={onChange}
                    placeholder="E-mail"
                    disabled
                />
                <div className="col-span-2">
                    <Input
                        name="phone"
                        autoComplete="tel"
                        value={formData.phone || ''}
                        onChange={onChange}
                        placeholder="Telefone"
                    />
                </div>
            </div>
        </div>
    );
};
